import { createSlice } from "@reduxjs/toolkit";


const token= localStorage.getItem('manufacturerToken')
const initialState = {
  login: token? true :false,
  token: token ? token : null,
  userProfile: {}

};

const LoginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    login: (state) => {
      state.login = true;
    },
    token: (state, action) => {
      state.token = action.payload;
    },
    userProfile: (state, action) => {
      state.userProfile = action.payload
    },
    logOut: (state) => {
      state.login = false
    }
   
  },
});

export const loginAction = LoginSlice.actions;
export default LoginSlice;
